import gsap from 'gsap';
import { ScrollToPlugin } from 'gsap/ScrollToPlugin';


/* eslint-disable */
export default function initSmoothScroll() {

	const url = new URL(window.location.href);
	const hash = url.hash;

	gsap.registerPlugin(ScrollToPlugin);


	function scrollToHash(hash) {
		if( !hash ) return;

		let offsetY = 0;
		const header = document.querySelector('header.header');
		const headerHeight = header.offsetHeight;
		let targetElement = document.querySelector(hash);

		if (hash === "#announcements" && !targetElement ) {
			targetElement = document.querySelector('.announcements-section');
		}


		if (targetElement) {
			setTimeout( () => {
				offsetY += headerHeight;
				gsap.to(window, { duration: 0.7, ease: 'expo.inOut', scrollTo: { y:targetElement, offsetY: offsetY } });
			}, 300);
		}

	}

	// Scroll to the element on initial load if there's a hash in the URL
	if (hash) {
		setTimeout(() => scrollToHash(hash), 300);
		// scrollToHash(hash);
	}

	const anchorLinks = document.querySelectorAll('.js-anchor-link');
	anchorLinks.forEach((anchorLink) => {
		anchorLink.addEventListener('click', (e) => {

			e.preventDefault();

			let offsetY = 0;
			let target = anchorLink.getAttribute('href');

			if (target.substring(0, 2) === '/#') {
				if (window.location.pathname === '/' ) {
					target = target.substring(1);
				} else {
					window.location.href = target;
					return;
				}
			}

			if( target === "#announcements" && !document.querySelector('#annoucements') ){
				target = ".announcements-section";
			}


			/*
			const toggleSectionHeight = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--toggle-section-height'));
			const headerHeight = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--header-height'));
			const announceSectionHeight = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--announcement-section-height'));
			const anchorNavPanelHeight = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--nav-anchorlinks-section-height'));
			*/
			// get header height
			const header = document.querySelector('header.header');
			const headerHeight = header.offsetHeight;

			offsetY += headerHeight;
			gsap.to(window, { duration: 1, ease: 'expo.inOut', scrollTo: { y: target, offsetY: offsetY } });

			if (document.body.API) {
				document.body.API.hideMenu();
			}
		});
	});

	/*
	new SmoothScroll({
		anchorLinks: '.js-anchor-link',
		extraOffset: function () {
			var totalHeight = 0;
			// jQuery('.js-fixed-nav-panel').each(function (e) {
			// 	var $box = jQuery(this);
			// 	var stickyInstance = $box.data('StickyScrollBlock');
			// 	if ($box.hasClass('header') ){
			// 		totalHeight += 0;
			// 	} else {
			// 		if (stickyInstance) {
			// 			stickyInstance.stickyFlag = false;
			// 			totalHeight += $box.outerHeight();
			// 			stickyInstance.onResize();
			// 		} else {
			// 			totalHeight += $box.css('position') === 'fixed' ? $box.outerHeight() : 0;
			// 		}
			// 	}
			// });

			// const announcementPanel = document.querySelector('.js-announcement-panel');
			// if (announcementPanel) {
			// 	const announcementPanelStyle = window.getComputedStyle(announcementPanel);
			// 	if (announcementPanelStyle.display !== 'none') {
			// 		totalHeight += announcementPanel.offsetHeight+100;
			// 	}
			// }

			const toggleSectionHeight = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--toggle-section-height'));
			const headerHeight = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--header-height'));
			const announceSectionHeight = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--announcement-section-height'));
			const anchorNavPanelHeight = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--nav-anchorlinks-section-height'));

			totalHeight = headerHeight + toggleSectionHeight + announceSectionHeight + anchorNavPanelHeight - 10;

			return totalHeight;
		},
		activeClasses: 'link',
		wheelBehavior: 'none',
		onBeforeScroll: function () {
			if (document.body.API) {
				document.body.API.hideMenu();
			}
		}
	});
	*/

}
